import { Component, Input, Output, EventEmitter, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'bz-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent implements OnInit {
  @Input() dateInput: Date;
  @Output() timeChange = new EventEmitter<Date>();
  @Input() isVisible: boolean = false;
  @Input() showIcon: boolean = true;
  @Input() showSeconds: boolean = false;

  hours: string;
  minutes: string;
  seconds: string;
  hoursArray: string[] = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  minutesArray: string[] = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));
  secondsArray: string[] = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));
  dropdownOpenHours: boolean = false;
  dropdownOpenMinutes: boolean = false;
  dropdownOpenSeconds: boolean = false;
  hoveredMinute: string | null = null;
  hoveredHour: string | null = null;
  hoveredSecond: string | null = null;

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.dateInput) {
      this.hours = this.dateInput.getHours().toString().padStart(2, '0');
      this.minutes = this.dateInput.getMinutes().toString().padStart(2, '0');
      this.seconds = this.dateInput.getSeconds().toString().padStart(2, '0');
    }
  }

  updateTime() {
    const updatedTime = new Date(this.dateInput);
    updatedTime.setHours(Number(this.hours));
    updatedTime.setMinutes(Number(this.minutes));
    updatedTime.setSeconds(Number(this.seconds));
    this.timeChange.emit(updatedTime);
  }

  confirmAndClose() {
    this.updateTime();
    this.isVisible = false;
  }

  toggleDropdownHours() {
    this.dropdownOpenMinutes = false;
    this.dropdownOpenSeconds = false;
    this.dropdownOpenHours = !this.dropdownOpenHours;
  }

  toggleDropdownMinutes() {
    this.dropdownOpenHours = false;
    this.dropdownOpenSeconds = false;
    this.dropdownOpenMinutes = !this.dropdownOpenMinutes;
  }

  toggleDropdownSeconds() {
    this.dropdownOpenHours = false;
    this.dropdownOpenMinutes = false;
    this.dropdownOpenSeconds = !this.dropdownOpenSeconds;
  }

  selectMinute(minute: string) {
    this.minutes = minute;
    this.updateTime();
  }

  selectHour(hours: string) {
    this.hours = hours;
    this.updateTime();
  }

  selectSecond(second: string) {
    this.seconds = second;
    this.updateTime();
  }
}